import { combineReducers } from 'redux';
import UserReducer from './UserReducer';
import FileReducer from './FileReducer';
import CompanyReducer from './CompanyReducer';

const appReducer = combineReducers({
    UserReducer,
    FileReducer,
    CompanyReducer,
});

const rootReducer = (state, action) => {
    if (action.type == 'LOGGED_OUT') {
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
